module.exports = __webpack_public_path__ + "img/new-year_in.10a03736.png";